export function rotate({
  angle,
  center,
  point,
}: {
  angle: number
  center: { x: number; y: number }
  point: { x: number; y: number }
}) {
  return {
    x: Math.cos(angle) * (point.x - center.x) - Math.sin(angle) * (point.y - center.y) + center.x,
    y: Math.sin(angle) * (point.x - center.x) + Math.cos(angle) * (point.y - center.y) + center.y,
  }
}

export function toRadians(angle: number) {
  return (angle * Math.PI) / 180
}
